import React,{useState, useEffect} from "react"
import { AutoSearchDropdown, InputBox, SelectDropDown, TextArea } from "../../../components/Custom"
import { H4FormLabel } from "../../../theme/Theme"
import { Box, Grid, Typography, CircularProgress, Button} from "@mui/material"
import ThemeColor from "../../../theme/ThemeColor"
import DisplayError from "../../../validation/DisplayError"
import HeaderName from "../../../components/Custom/HeaderName"
import { useLocation, useNavigate } from "react-router"
import validate from "../../../validation/validation";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux"
import { createBranchDetails, updateBranchDetails } from "../../../redux/Thunk/branchThunk";
import { statusList } from "../../utils/constant";
import { getOfficeList } from "../../../redux/Thunk/officeThunk"

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 200,
        },
    },
};

const NewBranch = () =>{
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {officeList}  = useSelector((state) => state.office)
    const {state} = useLocation()
    const [error, setError] = useState([]);
    const [loader, setLoader]= useState(false)
    const [editBranchDetails, setEditBranchDetails] = useState(state?.editDetails ? state?.editDetails :{})
    const [branchDetails, setBranchDetails] = useState({
        OfficeId:'',
        branchManagerName:'',
        email:'',
        mobile:'',
        branchName:'',
        status:statusList[0]?.value,
    })
  
    useEffect(() => {
        dispatch(getOfficeList({page:1, limit: 10000, role:'OfficeAdmin'}))
        if(Object.keys(editBranchDetails).length > 0){ 
            setBranchDetails({
                OfficeId: editBranchDetails?.OfficeId || '',
                branchManagerName: editBranchDetails?.branchManagerName || '',
                email: editBranchDetails?.email || '',
                mobile: editBranchDetails?.mobile?.toString() || '',
                branchName: editBranchDetails?.branchName || '',
                status: editBranchDetails?.status || '',
            });
        } 
    },[])

    const handleChange =(e) =>{
        setBranchDetails({...branchDetails, [e.target.name]:e.target.value})
    }
   
    let check_first_digit = branchDetails?.mobile ? branchDetails?.mobile[0] : 0 

    let validation_input = [  
        {tagid:'branchManagerName', text:branchDetails?.branchManagerName ??'', required: true, regex_name:'text', errmsg: 'Please Enter Manager Name.', allow_numbers: false, other_chars: ' ', min:3, max: 50},
        {tagid:'OfficeId', text:branchDetails?.OfficeId ??'', regex_name:'free_text', required: true, errmsg: 'Please Select Office Name.', min:1, max: 50},
        {tagid:'status', text:branchDetails?.status ??'', required: true, regex_name:'free_text', errmsg: 'Please Select Status.', min:1, max:50},
        {tagid:'branchName', text:branchDetails?.branchName ??'', required: true, regex_name:'text', errmsg: 'Please Enter Name.',allow_numbers: false, other_chars: ' ', min:3, max: 50},
        {tagid:'email', text: branchDetails?.email ??'', regex_name:'email', required: true, errmsg:'Please Enter Valid Email.'}, 
        Number(check_first_digit) <= 5 ? {tagid:'mobile', text:branchDetails?.mobile, required:true, regex_name: 'exact_x_digits', errmsg:'Please Enter Valid Number.' } : {tagid:'mobile', text:branchDetails?.mobile, regex_name: 'exact_x_digits', required: true, errmsg:'Please Enter Valid Number.', x_count:10 },
    ] 

    // Create and update Branch details
    const onClickSubmitForm = () =>{
        if(validate(validation_input)?.length == 0){
            setLoader(true)
           if(Object.keys(editBranchDetails)?.length == 0 ){ 
                // Create Branch Details 
                dispatch(createBranchDetails(branchDetails)).then((res)=>{
                    if(res.payload.success === false){
                        sweetalert('error', res?.payload?.message)
                    }else{
                        sweetalert('success', res?.payload?.message)
                        setBranchDetails({
                            OfficeId:'',
                            branchManagerName:'',
                            email:'',
                            mobile:'',
                            branchName:'',
                            status:'Active'
                        })
                        navigate("/dashboard/branchlist")
                    }  
                    setLoader(false)    
                }) 
            }else{   
                branchDetails.officeBranchId = editBranchDetails?.officeBranchId
                // Update Branch details
                dispatch(updateBranchDetails(branchDetails)).then((res)=>{
                    if(res.payload.success === false){
                        sweetalert('error', res?.payload?.message)
                    }else{
                        sweetalert('success', res?.payload?.message)
                        setBranchDetails({
                            OfficeId:'',
                            branchManagerName:'',
                            email:'',
                            mobile:'',
                            branchName:'',
                            status:'Active'
                        })
                        navigate("/dashboard/branchlist")
                    }  
                    setLoader(false)    
                }) 
            }
        }else{
            setError(validate(validation_input))
        }
    }

    const sweetalert = (variant, text) => {
        Swal.fire({
            icon: variant==='error' ? 'error' :'success',
            title: text , 
            button: "Ok!",
        }); 
    }

    return(
        <>
            <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
                <HeaderName headerName={Object.keys(editBranchDetails).length > 0 ? 'Edit Branch' :'Add Branch'} newForm = {false} onClickBackButton={()=> navigate("/dashboard/branchlist")} />
                <Box style={{backgroundColor:'#FFFFFF', margin:'5px 30px 5px 10px', border:'1px solid #FFFFF', borderRadius:'30px'}}>    
                    <Grid container spacing={2} style={{ display: 'flex', padding:'20px 20px', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
                        {/* Render input fields for 'Branch' */}
                            <Grid size={{ xs: 12, sm: 4, md: 4, lg:4 }}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Office Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                {/* <SelectDropDown
                                    id="OfficeId"
                                    name="OfficeId"
                                    placeholder="Enter Office Name"
                                    onChange={handleChange}
                                    value={branchDetails?.OfficeId}
                                    options={officeList?.data?.map((name)=> {return {value:name?.OfficeId, label:name?.OfficeName}})}
                                    sx={{ height: '50px', borderRadius: '10px', background: '#ffffff' }}
                                    MenuProps={MenuProps}
                                /> */}

                                <AutoSearchDropdown
                                    id="OfficeId"
                                    name="OfficeId"
                                    placeholder="Enter Office Name"
                                    onChange={handleChange}
                                    value={
                                        officeList?.data?.find((o) => o.OfficeId === branchDetails?.OfficeId) 
                                          ? {
                                              label: officeList?.data?.find((o) => o.OfficeId === branchDetails?.OfficeId)?.OfficeName,
                                              value: branchDetails?.OfficeId
                                            } 
                                          : null
                                      }
                                    options={officeList?.data?.map((name) => ({value: name?.OfficeId, label: name?.OfficeName}))}
                                    sx={{borderRadius: '10px', mt:0.5, background: '#ffffff' }}
                                />
                                <DisplayError error={error} fortagid='OfficeId'/>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md:4, lg:4}}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                <InputBox sx={{ borderRadius: '10px', backgroundColor: '#FFFFFF', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder="Enter Name"
                                    name='branchName'
                                    value={branchDetails?.branchName}
                                    onChange={handleChange}
                                />
                                <DisplayError error={error} fortagid='branchName' />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md:4, lg:4}}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Manager Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                <InputBox sx={{ borderRadius: '10px', backgroundColor: '#FFFFFF', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder="Enter Manager Name"
                                    name='branchManagerName'
                                    value={branchDetails?.branchManagerName}
                                    onChange={handleChange}
                                />
                                <DisplayError error={error} fortagid='branchManagerName' />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Email<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Enter Email'
                                    name='email'
                                    value={branchDetails?.email}
                                    onChange={handleChange}
                                />
                                <DisplayError error={error} fortagid='email'/>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Mobile Number<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <InputBox sx={{borderRadius:'10px', color:ThemeColor.palette.InputTextColor, border:"1px solid rgba(0, 0, 0, 0.3)", fontSize:'14px', width:'100%', p:0.1, pl:2}}  
                                    placeholder ="Enter Mobile Number" name='mobile' value={branchDetails?.mobile} 
                                    onChange={(e)=>{
                                        if(e.target.value.length <=10)handleChange(e)
                                    }} 
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const numericRegex = /^[0-9]*$/;
                                        if (!numericRegex.test(keyValue)) {
                                        e.preventDefault();
                                        }
                                    }} 
                                /> 
                                <DisplayError error={error} fortagid='mobile'/>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Status<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <SelectDropDown
                                    id="Status"
                                    name="status"
                                    placeholder="Enter Status"
                                    onChange={handleChange}
                                    Default={"Active"}
                                    value={branchDetails?.status}
                                    options={statusList}
                                    sx={{mt:0.5, height: '50px', borderRadius: '10px', background: '#ffffff' }}
                                />
                                <DisplayError error={error} fortagid='status'/>
                            </Grid>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 10, md: 10, lg:12 }} style={{marginTop:'10px', display:'flex', justifyContent:'center'}}>
                        <Button
                            id="save"
                            variant="contained"
                            disabled={loader}
                            onClick={onClickSubmitForm}
                            sx={{color: '#FFFFFF', backgroundColor: '#04AB44',
                                '&:hover': { backgroundColor: '#04AB44', color: '#FFFFFF' },
                                fontSize: '16px', fontWeight: '500', borderRadius:"10px", pl:5, pr:5, textTransform: 'none', boxShadow:'0px 4px 6px #e1e1e1', mb:4, letterSpacing:'1px'
                            }}>
                            {loader ? <CircularProgress size={20} color="inherit" /> : 'Save'}
                        </Button>
                    </Grid>
                </Box>
            </div>     
        </>
    )
}

export default NewBranch